// extracted by mini-css-extract-plugin
export default {"shields":"GithubShields_shields__olqv7"};